export function getContentType(route: string) {
  const regexp = /\/school\/course\/.*\/(.*)\//gm
  const matches = regexp.exec(route)
  return matches?.[1]
}
